// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dp-publish {
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.dp-publish__desc {
  font-size: 12px;
  color: #555;
  margin: 0;
}

.dp-publish__search input {
  width: 100%;
  box-sizing: border-box;
  padding: 6px 10px;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  font-size: 13px;
}

.dp-publish__search input:focus {
  outline: none;
  border-color: #16a085;
}

.dp-publish__error {
  padding: 8px 10px;
  background: #fdf2f2;
  border: 1px solid #f5c6cb;
  border-radius: 4px;
  color: #c0392b;
  font-size: 12px;
}

.dp-publish__message {
  padding: 8px 10px;
  border-radius: 4px;
  font-size: 12px;
}

.dp-publish__message--success {
  background: #f0fff4;
  border: 1px solid #a3d9b1;
  color: #1e7e34;
}

.dp-publish__message--error {
  background: #fdf2f2;
  border: 1px solid #f5c6cb;
  color: #c0392b;
}

.dp-publish__loading,
.dp-publish__empty {
  text-align: center;
  color: #888;
  font-size: 13px;
  padding: 20px 0;
}

.dp-publish__list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.dp-publish__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  background: #fff;
  gap: 8px;
}

.dp-publish__item-info {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
  flex: 1;
}

.dp-publish__item-name {
  font-size: 13px;
  font-weight: 500;
  color: #1a1a1a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dp-publish__item-status {
  display: inline-block;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  padding: 1px 6px;
  border-radius: 10px;
  width: fit-content;
}

.dp-publish__item-status--draft {
  background: #fff3cd;
  color: #856404;
}

.dp-publish__item-status--published {
  background: #d4edda;
  color: #155724;
}

.dp-publish__item-status--archived {
  background: #e9ecef;
  color: #6c757d;
}

.dp-publish__btn {
  flex-shrink: 0;
  padding: 5px 12px;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  background: #16a085;
  color: white;
  transition: background 0.15s;
}

.dp-publish__btn:hover:not(:disabled) {
  background: #1abc9c;
}

.dp-publish__btn:disabled {
  background: #b2dfdb;
  color: #555;
  cursor: default;
}

.dp-publish__btn--secondary {
  background: #6c757d;
  color: white;
}

.dp-publish__btn--secondary:hover:not(:disabled) {
  background: #7c868e;
}

.dp-publish__btn--secondary:disabled {
  background: #c0c5ca;
  color: #777;
}

.dp-publish__actions {
  display: flex;
  gap: 8px;
}

.dp-publish__actions .dp-publish__btn {
  flex: 1;
}

/* Template info block */
.dp-publish__template-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 10px;
  background: #f8f9fa;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
}

.dp-publish__info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
}

.dp-publish__info-label {
  font-weight: 600;
  color: #555;
}

.dp-publish__info-value {
  color: #1a1a1a;
}

.dp-publish__version-badge {
  display: inline-block;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  padding: 1px 6px;
  border-radius: 10px;
}

.dp-publish__version-badge--draft {
  background: #fff3cd;
  color: #856404;
}

.dp-publish__version-badge--published {
  background: #d4edda;
  color: #155724;
}

.dp-publish__version-badge--pendingapproval {
  background: #cce5ff;
  color: #004085;
}

/* Validation */
.dp-publish__validation {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.dp-publish__validation-summary {
  font-size: 11px;
  font-weight: 600;
  color: #555;
  padding: 6px 10px;
  background: #f0f1f3;
  border-radius: 4px;
}

.dp-publish__validation-section {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.dp-publish__validation-item {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  padding: 5px 8px;
  border-radius: 4px;
  font-size: 11px;
  line-height: 1.4;
}

.dp-publish__validation-item--error {
  background: #fdf2f2;
  border: 1px solid #f5c6cb;
  color: #c0392b;
}

.dp-publish__validation-item--warning {
  background: #fff8e1;
  border: 1px solid #ffe082;
  color: #8a6d3b;
}

.dp-publish__validation-item--info {
  background: #e8f4fd;
  border: 1px solid #b3d9f2;
  color: #31708f;
}

.dp-publish__validation-icon {
  flex-shrink: 0;
  font-size: 12px;
  line-height: 1.3;
}

.dp-publish__validation-key {
  font-weight: 600;
  white-space: nowrap;
}

.dp-publish__validation-msg {
  flex: 1;
}

.dp-publish__message--warning {
  background: #fff8e1;
  border: 1px solid #ffe082;
  color: #8a6d3b;
}

.dp-publish__message--info {
  background: #e8f4fd;
  border: 1px solid #b3d9f2;
  color: #31708f;
}
`, "",{"version":3,"sources":["webpack://./src/taskpane/components/PublishTemplate.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,OAAO;AACT;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB","sourcesContent":[".dp-publish {\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.dp-publish__desc {\n  font-size: 12px;\n  color: #555;\n  margin: 0;\n}\n\n.dp-publish__search input {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 6px 10px;\n  border: 1px solid #d0d0d0;\n  border-radius: 4px;\n  font-size: 13px;\n}\n\n.dp-publish__search input:focus {\n  outline: none;\n  border-color: #16a085;\n}\n\n.dp-publish__error {\n  padding: 8px 10px;\n  background: #fdf2f2;\n  border: 1px solid #f5c6cb;\n  border-radius: 4px;\n  color: #c0392b;\n  font-size: 12px;\n}\n\n.dp-publish__message {\n  padding: 8px 10px;\n  border-radius: 4px;\n  font-size: 12px;\n}\n\n.dp-publish__message--success {\n  background: #f0fff4;\n  border: 1px solid #a3d9b1;\n  color: #1e7e34;\n}\n\n.dp-publish__message--error {\n  background: #fdf2f2;\n  border: 1px solid #f5c6cb;\n  color: #c0392b;\n}\n\n.dp-publish__loading,\n.dp-publish__empty {\n  text-align: center;\n  color: #888;\n  font-size: 13px;\n  padding: 20px 0;\n}\n\n.dp-publish__list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.dp-publish__item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 10px;\n  border: 1px solid #e8e8e8;\n  border-radius: 6px;\n  background: #fff;\n  gap: 8px;\n}\n\n.dp-publish__item-info {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  min-width: 0;\n  flex: 1;\n}\n\n.dp-publish__item-name {\n  font-size: 13px;\n  font-weight: 500;\n  color: #1a1a1a;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dp-publish__item-status {\n  display: inline-block;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  padding: 1px 6px;\n  border-radius: 10px;\n  width: fit-content;\n}\n\n.dp-publish__item-status--draft {\n  background: #fff3cd;\n  color: #856404;\n}\n\n.dp-publish__item-status--published {\n  background: #d4edda;\n  color: #155724;\n}\n\n.dp-publish__item-status--archived {\n  background: #e9ecef;\n  color: #6c757d;\n}\n\n.dp-publish__btn {\n  flex-shrink: 0;\n  padding: 5px 12px;\n  border: none;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  background: #16a085;\n  color: white;\n  transition: background 0.15s;\n}\n\n.dp-publish__btn:hover:not(:disabled) {\n  background: #1abc9c;\n}\n\n.dp-publish__btn:disabled {\n  background: #b2dfdb;\n  color: #555;\n  cursor: default;\n}\n\n.dp-publish__btn--secondary {\n  background: #6c757d;\n  color: white;\n}\n\n.dp-publish__btn--secondary:hover:not(:disabled) {\n  background: #7c868e;\n}\n\n.dp-publish__btn--secondary:disabled {\n  background: #c0c5ca;\n  color: #777;\n}\n\n.dp-publish__actions {\n  display: flex;\n  gap: 8px;\n}\n\n.dp-publish__actions .dp-publish__btn {\n  flex: 1;\n}\n\n/* Template info block */\n.dp-publish__template-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 8px 10px;\n  background: #f8f9fa;\n  border: 1px solid #e8e8e8;\n  border-radius: 6px;\n}\n\n.dp-publish__info-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 12px;\n}\n\n.dp-publish__info-label {\n  font-weight: 600;\n  color: #555;\n}\n\n.dp-publish__info-value {\n  color: #1a1a1a;\n}\n\n.dp-publish__version-badge {\n  display: inline-block;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  padding: 1px 6px;\n  border-radius: 10px;\n}\n\n.dp-publish__version-badge--draft {\n  background: #fff3cd;\n  color: #856404;\n}\n\n.dp-publish__version-badge--published {\n  background: #d4edda;\n  color: #155724;\n}\n\n.dp-publish__version-badge--pendingapproval {\n  background: #cce5ff;\n  color: #004085;\n}\n\n/* Validation */\n.dp-publish__validation {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.dp-publish__validation-summary {\n  font-size: 11px;\n  font-weight: 600;\n  color: #555;\n  padding: 6px 10px;\n  background: #f0f1f3;\n  border-radius: 4px;\n}\n\n.dp-publish__validation-section {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.dp-publish__validation-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  padding: 5px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  line-height: 1.4;\n}\n\n.dp-publish__validation-item--error {\n  background: #fdf2f2;\n  border: 1px solid #f5c6cb;\n  color: #c0392b;\n}\n\n.dp-publish__validation-item--warning {\n  background: #fff8e1;\n  border: 1px solid #ffe082;\n  color: #8a6d3b;\n}\n\n.dp-publish__validation-item--info {\n  background: #e8f4fd;\n  border: 1px solid #b3d9f2;\n  color: #31708f;\n}\n\n.dp-publish__validation-icon {\n  flex-shrink: 0;\n  font-size: 12px;\n  line-height: 1.3;\n}\n\n.dp-publish__validation-key {\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.dp-publish__validation-msg {\n  flex: 1;\n}\n\n.dp-publish__message--warning {\n  background: #fff8e1;\n  border: 1px solid #ffe082;\n  color: #8a6d3b;\n}\n\n.dp-publish__message--info {\n  background: #e8f4fd;\n  border: 1px solid #b3d9f2;\n  color: #31708f;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
